<template>
  <thead>
    <tr>
      <th
        v-for="(item, index) in columns"
        :key="index"
        :class="{ 'text-end': index + 1 === columns.length }"
      >
        <span class="text-body-secondary">
          {{ item.title }}
        </span>
        <!-- <a class="list-sort text-body-secondary" href="#"></a> -->
      </th>
    </tr>
  </thead>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    columns: {
      required: true,
      type: Array,
    },
  },
});
</script>
